export const [PROPOSALS_FETCHED] = ['PROPOSALS_FETCHED']